/* BOLODOO desktop gallery share and As Seen On placement v1 */
(() => {
  if (customElements.get('desktop-product-extras')) return;
  class DesktopProductExtras extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      const section = this.closest('[data-main-product-section]');
      const info = section?.querySelector('.product__info-container');
      if (!info || !section.querySelector('.product__media-wrapper')) return;
      this.started = true;
      this.entries ||= ['.share-buttons', 'real-life-media'].map(selector => {
        const node = info.querySelector(selector);
        if (!node) return null;
        const home = document.createComment('Original mobile position: ' + selector);
        node.before(home);
        return { node, home };
      }).filter(Boolean);
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.align ||= () => {
        if (!this.desktop.matches) return;
        const gallery = [...this.parentNode.querySelectorAll('.product__media-list-wrapper .product__media-list')]
          .find(element => element.getBoundingClientRect().width > 0);
        if (!gallery) return;
        const media = gallery.getBoundingClientRect();
        const column = this.parentNode.getBoundingClientRect();
        this.parentNode.style.setProperty('--extras-offset', `${Math.max(0, media.left - column.left)}px`);
        this.parentNode.style.setProperty('--extras-width', `${Math.min(column.width, media.width)}px`);
      };
      this.update ||= () => {
        for (const { node, home } of this.entries) {
          if (!home.isConnected) continue;
          const destination = this.desktop.matches ? this : home.parentNode;
          if (node.parentNode === destination) continue;
          node.querySelector('dialog[open]')?.close();
          if (this.desktop.matches) this.append(node);
          else home.after(node);
        }
        this.hidden = !this.desktop.matches || !this.entries.length;
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(this.align);
      };
      this.desktop.addEventListener('change', this.update);
      this.resizeObserver = new ResizeObserver(this.align);
      this.resizeObserver.observe(this.parentNode);
      this.update();
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.update);
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.alignFrame);
      this.started = false;
    }
  }
  customElements.define('desktop-product-extras', DesktopProductExtras);
})();
